import React, { useState } from "react";
import { AppBar, makeStyles, Tab, Tabs } from "@material-ui/core";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: "100%",
    },
}));

const TabContainer = ({ tabs, variant = "fullWidth", width, children }) => {
    const classes = useStyles();
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const a11yProps = (index) => {
        return {
            id: `tab-${index}`,
            "aria-controls": `tabpanel-${index}`,
        };
    };

    return (
        <>
            <AppBar
                className={classes.root}
                position='static'
                color='default'
                elevation={1}
                style={{ width: width || "auto" }}
            >
                <Tabs
                    value={value}
                    variant={variant}
                    onChange={handleChange}
                >
                    {tabs.map((tab, index) => (
                        <Tab
                            key={index}
                            label={tab.label}
                            {...a11yProps(index)}
                        />
                    ))}
                </Tabs>
            </AppBar>
            {React.Children.map(children, (child, index) => {
                return React.cloneElement(child, {
                    value,
                    index
                });
            })}
        </>
    );
};

TabContainer.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    variant: PropTypes.oneOf(["standard", "fullWidth", "scrollable"]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    children: PropTypes.node.isRequired,
};

export default TabContainer;
